export function getTransactionErrorMessage(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- errors really are any
  error: any,
): string {
  // Handle user rejection cases
  if (
    error?.code === 'ACTION_REJECTED' ||
    error?.code === 4001 || // MetaMask user rejected
    error?.message?.toLowerCase().includes('user denied transaction signature') ||
    error?.message?.toLowerCase().includes('userrefusedondevice') ||
    (error?.message?.toLowerCase().includes('cancelled') && !error?.cancelled) ||
    error?.message?.toLowerCase().includes('rejected transaction') ||
    error?.data?.message?.toLowerCase().includes('rejected transaction')
  ) {
    return 'Transaction Rejected';
  }

  // Handle network switch rejection
  if (error?.code === 4902) {
    return 'Network not available in wallet';
  }

  // Handle transaction replacement cases
  if (error?.code === 'TRANSACTION_REPLACED') {
    if (error.cancelled) {
      return 'Transaction was cancelled';
    }
    if (error.replacement) {
      return 'Transaction was replaced with a new transaction (usually due to speed up)';
    }
  }

  // Handle Ledger specific errors
  if (
    error?.message?.toLowerCase().includes('ledger') ||
    error?.data?.message?.toLowerCase().includes('ledger')
  ) {
    return 'Error with Ledger device. Please ensure device is connected and unlocked';
  }

  // Handle pending transaction errors
  if (
    error?.code === -32002 &&
    error?.message?.toLowerCase().includes('pending') &&
    error?.data?.message?.toLowerCase().includes('pending')
  ) {
    return 'Transaction already pending in wallet. Please check your wallet';
  }

  // Handle internal issue of bad price calculation for support to see in screenshots
  if (
    error?.data?.message?.toLowerCase().includes('invalid amount') ||
    error?.message?.toLowerCase().includes('invalid amount')
  ) {
    return 'Price calculation is incorrect, contact support!';
  }

  // Handle internal issue of bad delegate for support to see in screenshots
  if (
    error?.data?.message?.toLowerCase().includes('invalid delegate') ||
    error?.message?.toLowerCase().includes('invalid delegate')
  ) {
    return 'Invalid delegate, select a different delegate';
  }

  // Handle insufficient funds
  if (
    error?.data?.message?.toLowerCase().includes('insufficient funds') ||
    error?.message?.toLowerCase().includes('insufficient funds')
  ) {
    return 'Your wallet does not have enough funds to complete this transaction. Please try again with a different wallet or add more funds to your wallet.';
  }

  // Handle insufficient balance for transaction
  if (
    error?.data?.message?.toLowerCase().includes('balance too low to proceed') ||
    error?.message?.toLowerCase().includes('balance too low to proceed')
  ) {
    return 'Your wallet does not have enough funds to complete this transaction. Please try again with a different wallet or add more funds to your wallet.';
  }

  // Handle nonce too low errors
  if (
    error?.data?.message?.toLowerCase().includes('nonce too low') ||
    error?.message?.toLowerCase().includes('nonce too low')
  ) {
    return 'Transaction nonce is too low. Please try again';
  }

  // Handle gas price too low
  if (
    error?.message?.toLowerCase().includes('max fee per gas less than block base fee') ||
    error?.data?.message?.toLowerCase().includes('max fee per gas less than block base fee')
  ) {
    return 'Gas price too low for current network conditions. Please try again';
  }

  // Handle timeout errors
  if (
    error?.code === 'TIMEOUT' ||
    error?.data?.message?.toLowerCase().includes('timeout') ||
    error?.message?.toLowerCase().includes('timeout')
  ) {
    return 'Transaction timed out. Your wallet connection is having issues. Disconnect and reconnect your wallet, then please try again';
  }

  // Handle network disconnection
  if (
    error?.data?.message?.toLowerCase().includes('network disconnected') ||
    error?.message?.toLowerCase().includes('network disconnected')
  ) {
    return 'Network connection lost. Please check your internet connection and try again';
  }

  // Handle wrong network errors
  if (
    error?.data?.message?.toLowerCase().includes('wrong network') ||
    error?.message?.toLowerCase().includes('wrong network')
  ) {
    return 'Wrong network selected. Please switch to the correct network';
  }

  // Handle user balance too low to pay for gas fees
  if (
    error?.data?.message?.toLowerCase().includes('insufficient funds for gas') ||
    error?.message?.toLowerCase().includes('insufficient funds for gas')
  ) {
    return 'Your wallet does not have enough funds to pay for gas fees. Please try again with a different wallet or add more funds to your wallet.';
  }

  // Handle sold out errors
  if (
    error?.message?.toLowerCase().includes('sold out') ||
    error?.data?.message?.toLowerCase().includes('sold out')
  ) {
    return 'Transaction cannot be completed, the token is now sold out';
  }

  // Handle could not verify merkle proof errors which means you are not on the allowlist
  if (
    error?.message?.toLowerCase().includes('could not verify merkle proof') ||
    error?.data?.message?.toLowerCase().includes('could not verify merkle proof')
  ) {
    return 'You are not on the allowlist for this claim';
  }

  // Handle already minted errors which means they've already claimed on an allowlist
  if (
    error?.message?.toLowerCase().includes('already minted') ||
    error?.data?.message?.toLowerCase().includes('already minted')
  ) {
    return 'You have used up all of your allowlist mints even though you are on the allowlist';
  }
  if (error?.message?.toLowerCase().includes('erc20: transfer amount exceeds balance')) {
    return 'You do not have the required amount of ERC20 tokens to complete this transaction.';
  }

  // Handle base case gas estimation failures
  if (
    error?.code === 'UNPREDICTABLE_GAS_LIMIT' ||
    error?.message?.toLowerCase().includes('cannot estimate gas') ||
    error?.data?.message?.toLowerCase().includes('cannot estimate gas')
  ) {
    console.error(error);
    return 'Unable to estimate gas for transaction. The transaction may fail. Please try again.';
  }

  // Handle call exceptions
  if (error?.code === 'CALL_EXCEPTION') {
    return 'Transaction failed due to contract execution error';
  }

  // For debugging purposes, log the full error
  console.error('Transaction error:', error);

  // Default error message
  return 'Transaction failed. Please try again. If it fails again, please contact support.';
}
